import { alpha, Box, InputBase, Typography, useTheme } from "@mui/material";
import type { ChangeEvent, Ref } from "react";

export type FlatRowTextareaProps = {
	label: string;
	value?: string;
	onChange?: (value: string) => void;
	onBlur?: () => void;
	inputRef?: Ref<HTMLTextAreaElement>;
	placeholder?: string;
	rows?: number;
	isLast?: boolean;
	error?: boolean;
	helperText?: string;
};

export const FlatRowTextarea = ({
	label,
	value,
	onChange,
	onBlur,
	inputRef,
	placeholder,
	rows = 3,
	isLast,
	error,
	helperText,
}: FlatRowTextareaProps) => {
	const theme = useTheme();

	const handleChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
		onChange?.(event.target.value);
	};

	return (
		<Box>
			<Box
				sx={{
					width: "100%",
					px: 2,
					py: 1.5,
					borderBottom: isLast
						? "none"
						: `1px solid ${alpha(theme.palette.grey[100], 0.6)}`,
				}}
			>
				<Typography
					fontSize={14}
					color={error ? theme.palette.error.main : theme.palette.grey[500]}
					mb={0.5}
				>
					{label}
				</Typography>
				<InputBase
					value={value ?? ""}
					onChange={handleChange}
					onBlur={onBlur}
					inputRef={inputRef}
					placeholder={placeholder}
					multiline
					minRows={rows}
					sx={{
						width: "100%",
						p: 0,
						"& textarea": {
							fontSize: 14,
							color: theme.palette.primary.main,
							resize: "none",
							minHeight: 60,
							"&::placeholder": {
								color: theme.palette.grey[300],
								fontWeight: 400,
								opacity: 1,
							},
						},
					}}
				/>
			</Box>
			{error && helperText && (
				<Typography
					fontSize={12}
					color={theme.palette.error.main}
					px={2}
					pb={0.6}
				>
					{helperText}
				</Typography>
			)}
		</Box>
	);
};
